// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"16177d38","725":"a8696584"}[chunkId] + ".chunk.js";
};